import React from "react";

export const LazyLoadedNotFoundPage = React.lazy(
  () => import("../pages/NotFoundPage")
);
export const LazyLoadedSharePage = React.lazy(
  () => import("../pages/SharePage")
);
